"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_native_svg_1 = require("react-native-svg");
const Info = (props) => {
    const { width, height, color } = props;
    return (react_1.default.createElement(react_native_svg_1.Svg, { width: width, height: height, viewBox: "0 0 24 24" },
        react_1.default.createElement(react_native_svg_1.G, { fill: "none", "fill-rule": "evenodd", opacity: ".8" },
            react_1.default.createElement(react_native_svg_1.Path, { fill: "none", d: "M0 0h24v24H0z" }),
            react_1.default.createElement(react_native_svg_1.Path, { d: "M12 4.8c-3.97 0-7.2 3.23-7.2 7.2s3.23 7.2 7.2 7.2 7.2-3.23 7.2-7.2-3.23-7.2-7.2-7.2zm1.595 10.97c-.397.156-1.771.813-2.563.115a1.006 1.006 0 0 1-.354-.79c0-.6.196-1.122.551-2.375.062-.237.139-.544.139-.788 0-.42-.16-.532-.593-.532-.21 0-.445.075-.657.154l.117-.48c.473-.191 1.065-.425 1.573-.425.761 0 1.322.38 1.322 1.102 0 .208-.036.573-.112.825l-.438 1.55c-.09.312-.254 1.003 0 1.208.25.202.84.094 1.132-.043l-.117.48zM12.87 9.6a.9.9 0 1 1 0-1.8.9.9 0 0 1 0 1.8z", fill: color }))));
};
Info.defaultProps = {
    color: '#111111',
    width: 24,
    height: 24,
};
exports.default = react_1.default.memo(Info);
